import { defineMessages, FormattedMessage } from '@faceup/localization'
import { type FragmentType, getFragmentData, graphql } from '../../../__generated__'
import { SentContent } from '../../../Components/SentContent/SentContent'

const messages = defineMessages('followUp.pages.reportSent.components.reportSentTestingCompany', [
  {
    id: 'testingDescription',
    defaultMessage:
      'You chose "Testing school" as an option. This helps you see how the form works. If you want to submit a real case of bullying, find your school and send the case to them. In the event of a life-threatening situation, call 911.',
  },
] as const)

const fragments = {
  ReportSentTestingCompany_publicReportSource: graphql(`
    fragment ReportSentTestingCompany_publicReportSource on PublicReportSource {
      id
      sourceType
    }
  `),
}

type Props = {
  channel: FragmentType<typeof fragments.ReportSentTestingCompany_publicReportSource>
}
export const ReportSentTestingCompany = ({ channel: _channel }: Props) => {
  const channel = getFragmentData(fragments.ReportSentTestingCompany_publicReportSource, _channel)
  return (
    <SentContent
      sourceType={channel.sourceType}
      description={<FormattedMessage message={messages.testingDescription} />}
    />
  )
}
